<div class="modal fade" #logInModal tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content text-center">
            <div class="modal-header border-0 pb-0 align-items-center justify-content-center">
                <div class="row">
                    <div class="col text-center">
                        <img style="height: 30px" src="../../../assets/img-gyan.png" alt="Gyan Logo" />
                        <span class="font-weight-bold section-title">Gyan</span>
                    </div>
                    <div class="col-auto">
                        <div type="button" class="gyan-popup-close" aria-label="Close" (click)="closeLogInModal()">
                            <div class="modal-close-icon"></div>
                        </div>
                        <!-- <button type="button" style="width: 20px !important; color: #2a3747 !important; height: 20px !important;" class="btn-close" (click)="closeSignUpModal()"
                            aria-label="Close"></button> -->
                    </div>
                </div>
            </div>
            <div class="modal-body">
                <div class="text-center d-block">
                    <div class="modal-title mb-2 Signup-header-font" id="logInModalLabel">Your Auto curating knowledge engine</div>
                    <p class="Signup-p-font">
                        Provide your topic of interest and Gyan's AI will discover content from preferred sources, check for relevance, surface major themes, and synthesize the
                        information, all in one place. Knowledge simplified.
                    </p>
                    <div class="Signup-header-font">Sign In</div>
                    <div class="btn-wrapper text-center mt-3">
                        <!-- <button class="custom-signin-btn gyan-signin-btn"><fa-icon [icon]="faKey"></fa-icon> <span>Sign in with Google</span></button> -->
                        <button disabled="true" class="gray-color custom-signin-btn-disable gyan-signin-btn" [attr.id]="'signinwith-google'" [attr.data-test]="'signinwith-google'">
                            <img class="img-fluid" style="padding-right: 10px" src="./../../assets/google.svg" alt="Google Icon" /><span>Sign in with Google</span>
                        </button>
                        <!-- <button
                            [disabled]="disableLoginButton"
                            [ngClass]="{ 'custom-signin-btn-disabled': disableLoginButton }"
                            (click)="azureLogin()"
                            class="custom-signin-btn gyan-signin-btn"
                        >
                            <fa-icon [icon]="faKey" style="padding-right: 13px"></fa-icon> <span>Sign in with Gyan</span>
                        </button> -->
                        <button
                            [disabled]="disableLoginButton || isLoading"
                            [ngClass]="{
                                'custom-signin-btn-disabled': disableLoginButton || isLoading,
                                'loading-state': isLoading,
                            }"
                            (click)="azureLogin()"
                            class="custom-signin-btn gyan-signin-btn"
                            [attr.id]="'signinwith-gyan'"
                            [attr.data-test]="'signinwith-gyan'"
                        >
                            <fa-icon *ngIf="!isLoading" [icon]="faKey" style="padding-right: 13px"></fa-icon>
                            <span *ngIf="!isLoading">Sign in with Gyan</span>
                            <span *ngIf="isLoading">
                                <img style="width: 25px !important; padding-right: 10px !important" src="./../assets/gifs/loader_sand.gif" alt="Processing icon" />Loading...</span
                            >
                        </button>
                        <hr class="mt-4" />
                        <div class="d-block text-center mt-4">
                            <button class="btn-custom btn-primary" (click)="openSignUpModal()">Sign Up</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<app-signup></app-signup>
